import React, {useCallback} from 'react';

import {Box} from '@buncha/components/core/view';
import {CommonScreens} from '@buncha/common/navigation/types';
import {CustomImage} from '@buncha/components/core/Image';
import {MainScreens} from '@buncha/navigation/types';
import {Touchable} from '@buncha/components/core/touchable';
import {navigation} from '@buncha/config/navigation';
import {styles} from './styles';

interface BarcodeImageProps {
  barcodeUrl: string;
}

const BarcodeImage: React.FC<BarcodeImageProps> = props => {
  const toggleSheet = useCallback(() => {
    navigation.navigate(MainScreens.Common, {
      screen: CommonScreens.ImagePreview,
      params: {imageUrl: props?.barcodeUrl, isMap: true},
    });
  }, [props?.barcodeUrl]);

  return (
    <Box style={[styles.containerStyle]}>
      <Touchable onPress={toggleSheet}>
        <CustomImage
          resizeMode="contain"
          style={styles.imageStyle}
          source={props?.barcodeUrl}
        />
      </Touchable>
    </Box>
  );
};

export default React.memo(BarcodeImage);
